// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__YE-aT","type":"styles_type__1Maau","choices":"styles_choices__vgXKE"};